module.exports = __webpack_public_path__ + "static/logo-aupo-999d85f0d01435e1811393950946ed8b.png";